
import storage from 'storage';
import auth from '../auth';

export default {
    translationCategory: 'login-form',
    components: {
    },
    data() {
        return {
            title: this.$appInfo.title,
            login: '',
            password: '',
            rememberStorage: storage.prop('loginForm_RememberMe', 'root', false),
            processing: false,
            page: null,
            createAccount: false,
            isLoading: false,
            inviteData: null,
            companyInviteData: null,
            doNotUseInviteData: false
        };
    },
    computed: {
        invite() {
            return this.$route.query.invite;
        },
        companyInvite() {
            return this.$route.query.companyInvite;
        },
        validationCode() {
            return this.$route.query.code;
        },
        validationToken() {
            return this.$route.query.validationToken;
        },
        emailValidation() {
            if (this.validationCode && this.validationToken) return {
                hash: this.validationToken,
                code: this.validationCode
            };
            return null;
        },
        authToken() {
            return this.$route.query?.authToken || this.$route.query?.auth;
        }
    },
    watch: {
        invite(v) {
            if (v) {
                this.processInvite();
            }
        },
        companyInvite(v) {
            if (v) {
                this.processCompanyInvite();
            }
        }
    },
    mounted() {
        if (__DEBUG__)
            window.login = this;
        if (this.validationToken) {
            this.page = 'registration';
        } else if (this.invite) {
            this.processInvite();
        } else if (this.companyInvite) {
            this.processCompanyInvite();
        }else if (this.rememberStorage.value || this.authToken) {
            var token = storage.prop('loginForm_RememberUser', 'root').value;
            if (this.authToken) {
                if (__DEBUG__)
                    console.debug('Auth token exists');
                token = {
                    Access: this.authToken,
                    Refresh: ''
                }
            }
            if (token && auth.tokens().Access !== token.Access) {
                if (__DEBUG__)
                    console.info('Set authenticated', { token });
                this.isLoading = true;

                //Skip authentication logic if we have authToken in query params
                auth.setAuthenticated(token, !!this.authToken).then(async (token) => {
                    if (!auth.isPublishMode()) {
                        await this.$locale.actions.refreshI18n(true);
                    }
                    if (token)
                        this.$router.push(this.$route.query.redirect || '/home');
                    else {
                        this.$notifyError('Your session has expired. Please relogin.');
                        this.$auth.logOut(true);
                        this.$router.push({ path: '/login-form' });
                    }
                }).catch(ex => {
                    this.$notifyError(ex);
                    console.error(ex);
                    this.isLoading = false;
                }).finally(() => {
                    if (this._isDestroyed) return;
                    this.isLoading = false;
                });
            }
        }
    },
    methods: {
        onBackToLogin() {
            this.page = 'login';
            this.doNotUseInviteData = false;
        },
        processInvite() {
            if (__DEBUG__)
                console.debug('Process invite');
            this.isLoading = true;
            this.$Data.getExternalApi('Security/GetInviteInfo', `token=${this.invite}`).then(r => {
                if (r.Success) {
                    this.inviteData = r.Data;
                    this.onCreateAccountClick();
                } else {
                    this.$notifyError(r.ErrorMessage);
                    console.error(r.ErrorMessage);
                }
            }).finally(() => this.isLoading = false);
        },
        processCompanyInvite() {
            if (__DEBUG__)
                console.debug('Process company invite');
            this.isLoading = true;
            this.$Data.getExternalApi('Company/GetCompanyInvitation', `token=${this.companyInvite}`).then(r => {
                if (r.Success) {
                    this.companyInviteData = r.Data;
                    this.onCreateAccountClick();
                } else {
                    this.$notifyError(r.ErrorMessage);
                    console.error(r.ErrorMessage);
                }
            }).finally(() => this.isLoading = false);
        },
        onCreateAccountClick() {
            this.createAccount = false;
            setImmediate(() => {
                if (this._isDestroyed) return;
                this.createAccount = true;
                this.page = 'registration';
            });
        },
        onRegistered(data) {
            this.page = 'login';
            if (data) {
                this.login = data.UserName;
                this.$notifySuccess('You have been sucessfully registered');
                if (__DEBUG__)
                    console.debug('Registered', data);
            }
        },
        onLoginClick(e) {
            if (!e.validationGroup.validate().isValid) {
                return;
            }

            this.processing = true;
            auth.logIn(this.login, this.password, !!this.rememberStorage.value).then(async ({ authenticated, errorMessage }) => {
                if (__DEBUG__)
                    console.info('log in', authenticated);
                if (authenticated) {
                    if (storage.prop('loginForm_RememberMe', 'root').value) {
                        storage.prop('loginForm_RememberUser', 'root').value = auth.tokens();
                    }
                    if (!auth.isPublishMode()) {
                        await this.$locale.actions.refreshI18n(true);
                    }

                    this.$router.push(this.$route.query.redirect || '/home');
                    e.validationGroup.reset();
                } else {
                    this.$notifyError(errorMessage || 'Incorrect username or password');
                    console.error(errorMessage || 'Incorrect username or password')
                }

                return null;
            })
            .catch(ex => {
                this.$notifyError(ex);
                console.error(ex);
            })
            .finally(() => {
                this.processing = false;
            });
        }
    }
};